import { shouldRefreshListOnEventsOpen } from "./conversation-list-state.js";

/** Coalesce rapid visibility toggles before REST reconciliation. */
export const VISIBILITY_RECONCILE_COALESCE_MS = 300;

export type InboxEventsOpenKind = "initial" | "reconnect";

/**
 * First successful open is `initial`. Any later open (after native EventSource
 * reconnect) is `reconnect`. Heartbeat SSE comments never open a new stream.
 */
export function classifyInboxEventsOpen(hasOpenedBefore: boolean): InboxEventsOpenKind {
  return hasOpenedBefore ? "reconnect" : "initial";
}

/**
 * Whether to refresh the conversation list after an SSE `onopen`.
 * Skips only while the same query's initial REST load is still in flight
 * (avoids aborting/replacing that first load). Reconnect uses the same guard.
 */
export function shouldRefreshListAfterEventsOpen(input: {
  openKind: InboxEventsOpenKind;
  initialLoadQueryKey: string | null;
  currentQueryKey: string | null;
}): boolean {
  if (input.currentQueryKey == null) {
    // Reconnect with no known query still reconciles once the key exists;
    // without a key, skip rather than firing an unbound refresh.
    return false;
  }
  void input.openKind;
  return shouldRefreshListOnEventsOpen({
    initialLoadQueryKey: input.initialLoadQueryKey,
    currentQueryKey: input.currentQueryKey,
  });
}

export function shouldRefreshMessagesAfterEventsOpen(input: {
  selectedConversationId: number | null;
}): boolean {
  return input.selectedConversationId != null;
}

/** Tab return is a recovery signal; ignore hidden/prerender states. */
export function shouldReconcileInboxOnVisibility(input: {
  visibilityState: string;
}): boolean {
  return input.visibilityState === "visible";
}
